import React from "react";
import "./dropdown.css"
import "./Button"
import Button from "./Button";
import Backlogbool  from "./Backlogbool";
import BacklogCount from "./BacklogCount";
// Removed @import as it belongs in the CSS file


function Dropdown(){
    return( 
        <div className="semCount-container">
            <div class="duration-selection">
            <p>Select your course duration in years</p>
        </div>
    <div class="radio-buttons options-grid">
  <label class="radio-button">
    <input type="radio" name="options" value="2"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">2</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="3"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">3</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="4"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">4</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="5"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">5</span>
  </label>
</div>

<div className="backlogBool">
  <p>Do you have any backlog?</p>
  <div className="backlogbool-options">
    <Backlogbool/>
  </div>
</div>

<div className="backlogCount">
  <p>In how many semesters you have backlog?</p>
<BacklogCount/>
</div>

<div class="button-container">
 <Button/>
</div>

 </div>

 );
}

export default Dropdown;